import { useState } from 'react';
import ModalPreview from './ModalPreview';

function OverlayCardProject({
    FrontCard,
    BackCard,
    width = 'w-[331px]',
    height = 'h-[363px]',
    certificateId,
    fixW,
    image,
    ic,
    setAskToConnectWallet,
}) {
    const [showOverlay, setShowOverlay] = useState(false);
    const [showModal, setShowModal] = useState(false);

    return (
        <div 
            className={`relative ${fixW} mr-5 ${width} ${height}`}
            onMouseEnter={() => setShowOverlay(true)}
            onMouseLeave={() => setShowOverlay(false)}
        >
            {/* Front Card */}
            <div className={`${width} ${height} cursor-pointer`}>
                <FrontCard ic={ic} image={image} />
            </div>

            {/* Overlay */}
            {showOverlay && (
                <div 
                    className={`absolute inset-0 z-50 transition-all duration-300 overflow-hidden flex flex-col justify-center  rounded-md`}
                    style={{
                        background: 'rgba(0, 0, 0, 0.50)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '4px'
                    }}
                >
                    {/* Expand Button */}
                  

            
                <button
                onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                }}
   
                    className=" text-white w-fit hover:scale-110 text-xs leading-6 cursor-pointer   flex items-center gap-2 absolute top-3 right-3  rounded-full p-2  transition-all duration-200  "
                >
                        Expand
                    <span  className={` bg-[#414141]  rounded-sm p-1 `}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <path d="M3.94123 9.76379V8.70496H2.04065L4.423 6.32261L3.67653 5.57614L1.29418 7.95849V6.0579H0.235352V9.76379H3.94123ZM6.32359 4.42202L8.70594 2.03967V3.94026H9.76476V0.234375H6.05888V1.2932H7.95947L5.57712 3.67555L6.32359 4.42202Z" fill="white"/>
                        </svg>
                    </span>
                </button>

                

                    <BackCard
                        ic={ic}
                        image={image}
                        certificateId={certificateId}
                        setAskToConnectWallet={setAskToConnectWallet}
                    />
                </div>
            )}

            {/* Modal Preview */}
            <ModalPreview
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                imageUrl={image}
                title={"Project Impact Certificate"}
                  width="w-[50rem]"
                // width={"w-[69.3125rem]"}
                // height={"h-[41.875rem]"}
            />
        </div>
    );
}

export default OverlayCardProject;
